import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles/base.css';
// Phase 6.7 B — `appearance:none` + parchment-+-ink palette for
// native form controls (radio / checkbox / select / date / text).
// CSS-only — no custom React components.
import './styles/form-elements.css';
// Phase 5 — Leaflet's default stylesheet ships the tile container,
// zoom controls, attribution bar etc. Imported once at the app
// root so MapScreen can pick it up without a per-screen include.
import 'leaflet/dist/leaflet.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
